export const HttpHeaders = {
    Authorization: 'Authorization',
    ContentType: 'Content-Type',
    CacheControl: 'Cache-Control',
    Expires: 'Expires',
    Accept: 'Accept',
    AcceptEncoding: 'Accept-Encoding',
};
